export default "skymp5-front/587fdc1066a51497f29c1072759726f2.gif";